import React from 'react';
import Modal from 'react-responsive-modal';
import { Auth } from "aws-amplify";

 const ModalContainer = ({title,message,close,open,login,refreshCacheAndReload,cacheBuster}) => {

    const signOut = () => {
        Auth.signOut()
          .then(res => {
            console.log(res)
          })
          .catch(e => {
            console.log(e)
          });
      };

    return(
        <Modal  open={open}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                onClose={close} center classNames={{modalGeneralPoliticas:'modalGeneralPoliticas' }}>

                <div className="boxModal loginModal">
                    <p className="tituloModal">{title}</p>
                    <hr className="barraModal"/>
                    <p className="detalleModal">{message}</p>
                    {login  && <button className='button-signOut' onClick={signOut}>Cerrar Sesión</button>}
                    {cacheBuster && <button className='button-signOut' onClick={refreshCacheAndReload}>Actualizar</button> }
                </div>

        </Modal>
    )

}
 
export default ModalContainer;